import React from 'react'
import {Row, Col} from 'react-bootstrap'
import {StaticImage} from 'gatsby-plugin-image'

import Section from '../../components/Section'

import RedCircle from './red-circle.inline.svg'

import * as styles from './Intro.module.scss'

const Intro = () => {
  return (
    <Section id="section-1" background="purple">
      <Row className="justify-content-center justify-content-lg-between">
        <Col
          md={7}
          lg={6}
          className="d-flex flex-column align-items-center align-items-lg-start gap-5 text-center text-lg-start text-white"
        >
          <div className={styles.redCircle}>
            <RedCircle className={styles.bgImage} />
            <div className={styles.content}>
              <h1 className="fw-semibold">
                Are you
                <br />
                <span>Chickenpox aware?</span>
              </h1>
              <p>
                Chickenpox is highly contagious. Whilst it is usually a mild
                disease, there can be serious complications. Read on to find out
                more about chickenpox. Be chickenpox aware.
              </p>
            </div>
          </div>
        </Col>
        <Col md={8} lg={5} className="mt-5 mt-lg-0 px-5 px-lg-0">
          <StaticImage
            className={styles.rabbit}
            src="../../assets/images/rabbit-only.png"
            alt="Toy rabbit with chickenpox"
            width={1000}
          />
        </Col>
      </Row>
    </Section>
  )
}

export default Intro
